import { render } from "./ClinicalFormulationDrugExemptionsDeleteModal.vue?vue&type=template&id=4beb6f2f"
import script from "./ClinicalFormulationDrugExemptionsDeleteModal.vue?vue&type=script&lang=js"
export * from "./ClinicalFormulationDrugExemptionsDeleteModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"app/javascript/packs/components/ClinicalFormulationDrugExemptionsDeleteModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4beb6f2f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4beb6f2f', __exports__)) {
    api.reload('4beb6f2f', __exports__)
  }
  
  module.hot.accept("./ClinicalFormulationDrugExemptionsDeleteModal.vue?vue&type=template&id=4beb6f2f", () => {
    api.rerender('4beb6f2f', render)
  })

}


export default __exports__